module.exports = __webpack_public_path__ + "static/media/ciep.9afa8aa9.png";